import _ from 'lodash';
import {Map} from 'immutable';

import {
    SET_FENCES_TO_BE_VALIDATED,
    SET_FENCE,
    SET_FENCE_UPDATED,
    REMOVE_FENCE,
    CLEAR_FENCE,
} from './actions';

const validation= (state = Map({ fencesToBeValidated: [], fencesMap: Map(), updatedFence: { updated: false, geo: null} }), action) => {
    if (action.type === SET_FENCES_TO_BE_VALIDATED) {
        return state.setIn(['fencesToBeValidated'], action.payload.fences);
    }
    if (action.type === SET_FENCE) {
        return state
            .setIn(['fencesMap', action.payload.fence._id], action.payload.fence)
            .setIn(['updatedFence'], { updated: false, geo: null});
    }
    if (action.type === REMOVE_FENCE) {
        return state
            .removeIn(['fencesMap', action.payload.fenceId]);
    }
    if (action.type === SET_FENCE_UPDATED) {
        return state.setIn(['updatedFence'], { updated: true, geo: action.payload.geo});
    }
    if (action.type === CLEAR_FENCE) {
        let newFence = state.getIn(['fencesMap', action.payload.fenceId]);
        if (!_.isUndefined(newFence)) {
            newFence.geo = null;
            return state.setIn(['fencesMap', action.payload.fenceId], newFence);
        }
        return state;
    }
    return state;
};

export default validation;


// WEBPACK FOOTER //
// ./src/validation/reducer.js